/** 1890 → «1 890,00»; null → '' */
export const formatRequestPrice = (value: number | null | undefined): string =>
    value == null
        ? ''
        : value.toLocaleString('ru-RU', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });

export const sanitizeRequestPriceInput = (raw: string): string => {
    const s = raw.replace(/[^\d\s\u00a0\u202f.,]/g, '').replace(/\./g, ',');
    const comma = s.indexOf(',');
    if (comma === -1) return s;
    const fraction = s.slice(comma + 1).replace(/\D/g, '').slice(0, 2);
    return `${s.slice(0, comma)},${fraction}`;
};

/** «1 890,00 ₽» → 1890; «1890.5» → 1890.5; пусто или мусор → null */
export const parseRequestPrice = (value: string): number | null => {
    const cleaned = value
        .replace(/[\s\u00a0\u202f]/g, '')
        .replace(/₽|руб\.?/gi, '')
        .replace(',', '.');

    if (!cleaned || cleaned === '.') return null;

    const parsed = Number(cleaned);
    if (!Number.isFinite(parsed) || parsed < 0) return null;

    return Math.round(parsed * 100) / 100;
};